import { gql } from '@grandvisionhq/graphql';
import { recreateOrderedCheckoutResult } from '../fragments/recreate-ordered-checkout-result.js';

const RECREATE_ORDERED_CHECKOUT = gql`
  mutation RecreateOrderedCheckout($orderedCheckoutInput: OrderedCheckoutInput!) {
    recreateOrderedCheckout(input: $orderedCheckoutInput) {
      ...RecreateOrderedCheckoutFragment
    }
  }
  ${recreateOrderedCheckoutResult}
`;

export { RECREATE_ORDERED_CHECKOUT };
//# sourceMappingURL=recreate-ordered-checkout.js.map
